(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["growth-client"] && !Shopify.designMode) return;
  try {
    (() => {
const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_id", "keyword_id", "prompt_id", "gclid", "gbraid", "wbraid"];
const LIMIT = 90 * 86400000;
const STORAGE_KEY = "growth-acquisition-attribution-v04";
let memory = null;
let withdrawn = false;
const intents = new Map();
const rememberIntent = (page, intent) => intents.set(page, intent);
const currentIntent = (page) => intents.get(page) || {};
function cleanParameter(value) {
    if (!value || value.length > 300 || /[\r\n<>@]|%40|%0[ad]|\+?\d[\d\s()-]{8,}/i.test(value))
        return null;
    return value.trim();
}
function cleanClickId(value) {
    return typeof value === 'string' && /^[A-Za-z0-9._~-]{1,512}$/.test(value) ? value : null;
}
function readTouch(context, href, referrer, now = new Date()) {
    const url = new URL(href);
    let origin = null;
    try {
        const ref = new URL(referrer);
        if (["http:", "https:"].includes(ref.protocol) && ref.origin !== url.origin)
            origin = ref.origin;
    }
    catch { /* no referrer */ }
    const touch = { page_id: context.page_id, language: context.language, path: context.path, at: now.toISOString(), referrer_origin: origin };
    for (const key of keys)
        touch[key] = ["gclid", "gbraid", "wbraid"].includes(key) ? cleanClickId(url.searchParams.get(key)) : cleanParameter(url.searchParams.get(key));
    return touch;
}
function mergeHistory(prior, current, consent, now = Date.now()) {
    const valid = (touch) => !!touch && Number.isFinite(Date.parse(touch.at)) && now - Date.parse(touch.at) >= 0 && now - Date.parse(touch.at) <= LIMIT;
    const nonDirect = !!(current.utm_source || current.referrer_origin || current.gclid || current.gbraid || current.wbraid);
    return { first_touch: prior && valid(prior.first_touch) ? prior.first_touch : current,
        last_non_direct: nonDirect ? current : prior && valid(prior.last_non_direct) ? prior.last_non_direct : null,
        conversion_touch: current, consent, coverage: consent ? "consented" : "session_only" };
}
function capture(context) {
    let stored = null;
    try {
        const value = localStorage.getItem(STORAGE_KEY);
        if (value && !withdrawn) {
            const candidate = JSON.parse(value);
            if (candidate.consent === true && candidate.first_touch?.at)
                stored = candidate;
        }
    }
    catch { /* memory-only attribution still works */ }
    memory = mergeHistory(memory || stored, readTouch(context, location.href, document.referrer), !!(memory?.consent || stored?.consent));
    if (memory.consent) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(memory));
        }
        catch {
            memory.coverage = "storage_unavailable";
        }
    }
    return memory;
}
function setConsent(history, consent) {
    withdrawn = !consent;
    memory = { ...history, consent, coverage: consent ? "consented" : "session_only" };
    try {
        if (consent)
            localStorage.setItem(STORAGE_KEY, JSON.stringify(memory));
        else
            localStorage.removeItem(STORAGE_KEY);
    }
    catch {
        memory.coverage = "storage_unavailable";
    }
    return memory;
}
function clearAttributionConsent() {
    withdrawn = true;
    memory = null;
    let removed = true;
    try {
        localStorage.removeItem(STORAGE_KEY);
    }
    catch {
        removed = false;
    }
    if (typeof window !== "undefined")
        window.dispatchEvent(new Event("growth-attribution-withdrawn"));
    return removed;
}
function draftLinks(context, reference, market, contacts) {
    const ru = context.language === "ru";
    const safeMarket = ["MNG", "KAZ", "OTHER", "UNKNOWN"].includes(market) ? market : "UNKNOWN";
    const safeReference = /^NR-[a-f0-9]{32}$/.test(reference) ? reference : "unlinked";
    const subject = `[NAIRY][${safeReference}][${context.page_id}][${safeMarket}] ${ru ? "Запрос по подбору питателя" : "Feeder application enquiry"}`;
    const greeting = ru ? "Здравствуйте, NAIRY! Хочу обсудить применение питателя." : "Hello NAIRY. I would like to discuss a feeder application.";
    const originPage = context.origin_page_id && /^(PG-0[1-4]|WEB-[A-Z]+)$/.test(context.origin_page_id) ? ` Origin: ${context.origin_page_id}.` : "";
    const summary = `${greeting} Ref: ${safeReference}. Page: ${context.page_id}. Market: ${safeMarket}. Product: ${context.product_interest}. Context: ${context.application_code}.${originPage}`;
    const origin = typeof window === "undefined" ? "http://localhost:3000" : window.location.origin;
    const body = `${summary}\nPage: ${origin}${context.path}\n${ru ? "Страна/объект: [укажите]. Материал/задача: [укажите]." : "Country/site: [please add]. Material/problem: [please add]."}`;
    const email = `mailto:${contacts.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    return { email: email.length <= 1800 ? email : `mailto:${contacts.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(summary)}`,
        whatsapp: `https://wa.me/${contacts.whatsapp}?text=${encodeURIComponent(summary)}`, body };
}


const contract = {
  "acknowledgement": {
    "accepted_json_value": true,
    "marketing_consent": false,
    "optional_attribution_consent": "separate",
    "purpose": "equipment_inquiry_response_only",
    "required": true
  },
  "contract_sha256": "5e0ee54e37f244f968834ad3f82dc456b22438d63316e8178ae9ac14d4d2ae8a",
  "contract_version": "production-inquiry.v1",
  "endpoint": "https://ingest.nrmech.com/v1/public/inquiries",
  "locales": {
    "en": {
      "content_sha256": "fc72f369d796695cbeafd825dc3c878240f6fc3f05f188066271a3ef9adf58c5",
      "text": "I have read the Privacy Policy and understand that NAIRY will use the information I submit to respond to this equipment inquiry, including contacting me by email, phone, or WhatsApp."
    },
    "ru": {
      "content_sha256": "1ed5ae98c174e6b4ddc38a0c44e5aaf88355beb6e72089426b11757cbbd8f610",
      "text": "Я ознакомился(-лась) с Политикой конфиденциальности и понимаю, что NAIRY будет использовать отправленные мной данные для ответа на запрос по оборудованию, включая связь по электронной почте, телефону или WhatsApp."
    }
  },
  "notice_version": "nrmech-inquiry-privacy.v1",
  "privacy_page": {
    "base_path": "/policies/privacy-policy",
    "id": "WEB-NOTICE"
  },
  "receipt": {
    "contract_version": "production-inquiry.v1",
    "environment": "production",
    "http_status": [
      200,
      201
    ],
    "mailbox_receipt": "requires_independent_user_inbox_confirmation",
    "notification_status": [
      "queued",
      "sending",
      "retry",
      "sent",
      "dead",
      "not_required"
    ],
    "persisted_in_growth_os": true,
    "reference_pattern": "^NR-[a-f0-9]{32}$",
    "status": "received",
    "submission_id": "must_equal_submitted_uuid"
  },
  "schema_version": "growth-os.production-notice-contract.v1",
  "supported_locales": [
    "en",
    "ru"
  ]
};
function freezeContract(value) {
  if (value && typeof value === 'object') {
    Object.values(value).forEach(freezeContract);
    Object.freeze(value);
  }
  return value;
}
const NOTICE_CONTRACT = freezeContract(contract);


const TAB_KEY = 'growth-shopify-session-v03';
const UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
const NOTIFICATION_STATUSES = new Set(NOTICE_CONTRACT.receipt.notification_status);

function contractFailure(code) {
  throw new Error(code);
}

function freezeTree(value) {
  if (value && typeof value === 'object' && !Object.isFrozen(value)) {
    for (const child of Object.values(value)) freezeTree(child);
    Object.freeze(value);
  }
  return value;
}

function validateProductionReceipt(httpStatus, receipt, submittedUuid) {
  if (!UUID_PATTERN.test(submittedUuid)
      || !NOTICE_CONTRACT.receipt.http_status.includes(httpStatus)
      || !receipt || typeof receipt !== 'object' || Array.isArray(receipt)
      || receipt.environment !== 'production'
      || receipt.persisted_in_growth_os !== true
      || receipt.contract_version !== NOTICE_CONTRACT.contract_version
      || receipt.status !== 'received'
      || receipt.submission_id !== submittedUuid
      || typeof receipt.reference !== 'string'
      || !/^NR-[a-f0-9]{32}$/.test(receipt.reference)
      || !NOTIFICATION_STATUSES.has(receipt.notification_status)) {
    contractFailure('invalid_production_receipt');
  }
  return receipt;
}

async function productionSubmit(endpoint, payload, key, { fetchImpl = globalThis.fetch } = {}) {
  if (endpoint !== NOTICE_CONTRACT.endpoint) contractFailure('endpoint_unavailable');
  if (!payload || !UUID_PATTERN.test(key) || payload.submission_id !== key
      || payload.notice_acknowledged !== true
      || payload.notice_version !== NOTICE_CONTRACT.notice_version
      || !NOTICE_CONTRACT.supported_locales.includes(payload.language)) {
    contractFailure('invalid_production_request');
  }
  const response = await fetchImpl(NOTICE_CONTRACT.endpoint, {
    method: 'POST', credentials: 'omit', redirect: 'error', cache: 'no-store',
    headers: { 'Content-Type': 'application/json', 'Idempotency-Key': key },
    body: JSON.stringify(payload), signal: AbortSignal.timeout(12000),
  });
  if (!response || response.redirected === true || ![200, 201].includes(response.status)) {
    contractFailure('unconfirmed_http_response');
  }
  const receipt = await response.json();
  return validateProductionReceipt(response.status, receipt, key);
}

function createPendingSubmission({ uuid = () => crypto.randomUUID(), submit = productionSubmit } = {}) {
  let submissionId = uuid();
  let pendingPayload = null;
  let state = 'editing';
  let inFlight = null;
  let acceptedReceipt = null;
  let blockedByWithdrawal = false;
  if (!UUID_PATTERN.test(submissionId)) contractFailure('invalid_submission_uuid');

  const view = () => ({ submissionId, pendingPayload, state, blockedByWithdrawal });
  const prepare = candidate => {
    if (pendingPayload) return pendingPayload;
    if (!candidate || candidate.notice_acknowledged !== true
        || candidate.notice_version !== NOTICE_CONTRACT.notice_version
        || !NOTICE_CONTRACT.supported_locales.includes(candidate.language)) {
      contractFailure('invalid_production_request');
    }
    const copied = JSON.parse(JSON.stringify({ ...candidate, submission_id: submissionId }));
    pendingPayload = freezeTree(copied);
    state = 'pending';
    return pendingPayload;
  };
  const attempt = candidate => {
    if (inFlight) return inFlight;
    if (acceptedReceipt) return Promise.resolve(acceptedReceipt);
    if (blockedByWithdrawal) return Promise.reject(new Error('pending_attribution_withdrawn'));
    let payload;
    try { payload = prepare(candidate); }
    catch (error) { return Promise.reject(error); }
    state = 'sending';
    inFlight = Promise.resolve().then(() => submit(NOTICE_CONTRACT.endpoint, payload, submissionId))
      .then(receipt => {
        acceptedReceipt = receipt;
        state = 'accepted';
        return receipt;
      }).catch(error => {
        state = 'uncertain';
        throw error;
      }).finally(() => { inFlight = null; });
    return inFlight;
  };
  const editedAfterAcceptance = () => {
    if (state !== 'accepted') return false;
    submissionId = uuid();
    if (!UUID_PATTERN.test(submissionId)) contractFailure('invalid_submission_uuid');
    pendingPayload = null;
    acceptedReceipt = null;
    blockedByWithdrawal = false;
    state = 'editing';
    return true;
  };
  const withdrawAttribution = () => {
    if (pendingPayload?.attribution?.consent === true && state !== 'accepted') {
      blockedByWithdrawal = true;
    }
    return view();
  };
  return { view, prepare, attempt, editedAfterAcceptance, withdrawAttribution };
}

function createInputFreeze(form) {
  const originals = new Map();
  return frozen => {
    for (const control of form.querySelectorAll('input, select, textarea')) {
      if (frozen) {
        if (!originals.has(control)) originals.set(control, control.disabled);
        control.disabled = true;
      } else if (originals.has(control)) {
        control.disabled = originals.get(control);
      }
    }
    if (!frozen) originals.clear();
    form.dataset.growthPendingFrozen = String(frozen);
  };
}

function normalizedAttribution(history, context, market, product, application, cta) {
  const touch = history.last_non_direct || history.first_touch;
  const host = touch.referrer_origin ? new URL(touch.referrer_origin).hostname : '';
  const paidClick = !!(touch.gclid || touch.gbraid || touch.wbraid);
  const source = touch.utm_source || (paidClick ? 'google' : /(^|\.)google\./.test(host) ? 'google' : /(^|\.)bing\.com$/.test(host) ? 'bing' : /(^|\.)chatgpt\.com$/.test(host) ? 'chatgpt' : /(^|\.)perplexity\.ai$/.test(host) ? 'perplexity' : host || 'direct');
  const term = touch.utm_medium === 'cpc' ? touch.utm_term || null : null;
  return { ...history, source, medium: touch.utm_medium || (paidClick ? 'cpc' : touch.referrer_origin ? 'referral' : 'none'), campaign: touch.utm_campaign || null,
    keyword_or_prompt: { kind: term ? 'paid_keyword' : 'unknown', value: term, evidence_type: term ? 'url_parameter' : 'none' },
    landing_page: history.first_touch.path, cta, inquiry_channel: 'form', market, language: context.language,
    product_interest: product, application, utm_source: touch.utm_source || null, utm_medium: touch.utm_medium || null,
    utm_campaign: touch.utm_campaign || null, utm_term: touch.utm_term || null, utm_content: touch.utm_content || null };
}



function isSystemTestInquiry(submitted) {
  return /^\[(?:SYSTEM TEST|系统测试)(?:\s|\/|\])/i.test(String(submitted?.application || ''));
}
function createAdsReceiptMeasurement(win, doc, { now = () => Date.now() } = {}) {
  const key = 'nairy-ads-receipt-v1', ttl = 90 * 86400000;
  const seen = new Map();
  let loaded = false;
  const allowed = () => {
    try {
      const p = win.Shopify?.customerPrivacy;
      return p?.analyticsProcessingAllowed?.() === true && p?.marketingAllowed?.() === true
        && p?.saleOfDataAllowed?.() === true;
    } catch { return false; }
  };
  doc.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) { try { win.localStorage.removeItem(key); } catch {} }
  });
  const accepted = (receipt, submitted, consent) => {
    if (isSystemTestInquiry(submitted)) return 'test_excluded';
    try {
      if (consent !== true || !allowed()) return 'not_sent';
      validateProductionReceipt(200, receipt, submitted?.submission_id);
    } catch { return 'not_sent'; }
    if (!loaded) {
      loaded = true;
      try {
        const rows = JSON.parse(win.localStorage.getItem(key) || '[]');
        if (Array.isArray(rows)) for (const r of rows.slice(-500)) {
          if (Array.isArray(r) && UUID_PATTERN.test(r[0]) && Number.isFinite(r[1])
              && now() >= r[1] && now() - r[1] < ttl) seen.set(r[0], r[1]);
        }
      } catch {}
    }
    for (const [id, at] of seen) if (now() - at >= ttl) seen.delete(id);
    if (seen.has(receipt.submission_id)) return 'already_queued';
    try {
      win.dataLayer = win.dataLayer || [];
      win.dataLayer.push({event:'nairy_inquiry_received', nairy_inquiry_transaction_id:receipt.submission_id});
    } catch { return 'not_sent'; }
    seen.set(receipt.submission_id, now());
    while (seen.size > 500) seen.delete(seen.keys().next().value);
    try { win.localStorage.setItem(key, JSON.stringify(Array.from(seen))); } catch {}
    return 'queued'; // A queued tag event is not proof of delivery to Google.
  };
  return {accepted};
}

function createInquiryMeasurement(win, doc, { now = () => Date.now() } = {}) {
  const target = 'G-8ZBSRLX05D';
  const seenKey = 'nairy-inquiry-measurement-v1';
  const ttl = 90 * 86400000;
  const seen = new Map();
  let storageLoaded = false;
  const allowed = consent => {
    try {
      const privacy = win.Shopify?.customerPrivacy;
      return consent === true && privacy?.analyticsProcessingAllowed?.() === true
        && privacy?.marketingAllowed?.() === true && privacy?.saleOfDataAllowed?.() === true;
    } catch { return false; }
  };
  const cleanContext = context => ({
    page_id: /^(PG-0[1-4]|WEB-[A-Z]+)$/.test(context.page_id || '') ? context.page_id : 'UNKNOWN',
    product_interest: ['belt', 'gzg', 'apron', 'grizzly'].includes(context.product_interest) ? context.product_interest : 'unknown',
    market: ['MNG', 'KAZ', 'OTHER', 'UNKNOWN'].includes(context.market) ? context.market : 'UNKNOWN',
    language: ['en', 'ru'].includes(context.language) ? context.language : 'unknown',
    page_location: win.location.origin + win.location.pathname,
    page_referrer: '',
    send_to: target,
  });
  const loadSeen = () => {
    if (storageLoaded) return;
    storageLoaded = true;
    try {
      const values = JSON.parse(win.localStorage.getItem(seenKey) || '[]');
      if (Array.isArray(values)) for (const pair of values.slice(-500)) {
        if (Array.isArray(pair) && UUID_PATTERN.test(pair[0]) && Number.isFinite(pair[1])
          && now() >= pair[1] && now() - pair[1] < ttl) seen.set(pair[0], pair[1]);
      }
    } catch {}
  };
  const saveSeen = () => {
    for (const [id, at] of seen) if (now() - at >= ttl) seen.delete(id);
    try { win.localStorage.setItem(seenKey, JSON.stringify(Array.from(seen).slice(-500))); } catch {}
  };
  const accepted = (receipt, submitted, context, consent) => {
    if (isSystemTestInquiry(submitted)) return 'test_excluded';
    if (!allowed(consent) || typeof win.gtag !== 'function') return 'not_sent';
    try { validateProductionReceipt(200, receipt, submitted?.submission_id); } catch { return 'not_sent'; }
    loadSeen();
    if (seen.has(receipt.submission_id)) return 'already_queued';
    seen.set(receipt.submission_id, now());
    saveSeen();
    try {
      win.gtag('event', 'generate_lead', {
        ...cleanContext(context), event_id: receipt.submission_id, lead_source: 'website_form',
      });
      return 'queued';
    } catch {
      seen.delete(receipt.submission_id);
      saveSeen();
      return 'not_sent';
    }
  };
  const contact = (channel, context, consent) => {
    if (!['email', 'whatsapp'].includes(channel) || !allowed(consent) || typeof win.gtag !== 'function') return 'not_sent';
    try {
      win.gtag('event', 'contact_click', { ...cleanContext(context), contact_channel: channel });
      return 'queued';
    } catch { return 'not_sent'; }
  };
  const withdrawal = () => {
    if (!allowed(true)) {
      try { win.localStorage.removeItem(seenKey); } catch {}
    }
  };
  doc.addEventListener('visitorConsentCollected', withdrawal);
  return { accepted, contact };
}

function initializeGrowthTheme(doc = document, win = window, dependencies = {}) {
  const allRoots = Array.from(doc.querySelectorAll('[data-growth-contact]'));
  const pairs = allRoots.flatMap(root => {
    try {
      const data = root.querySelector('[data-growth-context]');
      return data ? [{ root, context: JSON.parse(data.textContent) }] : [];
    } catch { return []; }
  });
  if (!pairs.length) return;
  const measurement = createInquiryMeasurement(win, doc);
  const adsMeasurement = createAdsReceiptMeasurement(win, doc);
  const contexts = pairs.map(pair => pair.context);
  const context = contexts[0];
  const url = new URL(win.location.href);
  const allowedMarkets = ['MNG', 'KAZ', 'OTHER', 'UNKNOWN'];
  const allowedProducts = ['belt', 'gzg', 'apron', 'grizzly', 'unknown'];
  let market = allowedMarkets.includes(url.searchParams.get('market')) ? url.searchParams.get('market') : 'UNKNOWN';
  let product = allowedProducts.includes(url.searchParams.get('product_interest')) ? url.searchParams.get('product_interest') : context.product_interest;
  const origin = url.searchParams.get('origin_page_id');
  if (/^(PG-0[1-4]|WEB-[A-Z]+)$/.test(origin || '')) contexts.forEach(c => { c.origin_page_id = origin; });
  let storageFailed = false;
  let acceptedReference = 'unlinked';
  const controllers = [];
  const platformAllows = () => {
    try { return win.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true
      && win.Shopify?.customerPrivacy?.marketingAllowed?.() === true
      && win.Shopify?.customerPrivacy?.saleOfDataAllowed?.() === true; }
    catch { return false; }
  };
  const essentialTouch = () => ({ page_id: context.page_id, language: context.language, path: context.path, at: new Date().toISOString() });
  let history = mergeHistory(null, essentialTouch(), false);
  try {
    if (platformAllows()) {
      const prior = JSON.parse(win.sessionStorage.getItem(TAB_KEY) || win.localStorage.getItem(STORAGE_KEY) || 'null');
      if (prior?.consent === true) history = mergeHistory(prior, readTouch(context, win.location.href, doc.referrer), true);
    }
  } catch { storageFailed = true; }
  const persist = () => {
    if (!(history.consent && platformAllows())) history = mergeHistory(null, essentialTouch(), false);
    try {
      if (history.consent && platformAllows()) {
        win.sessionStorage.setItem(TAB_KEY, JSON.stringify(history));
        win.localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
      } else {
        win.sessionStorage.removeItem(TAB_KEY); win.localStorage.removeItem(STORAGE_KEY);
        win.sessionStorage.removeItem('growth-shopify-session-v01'); win.localStorage.removeItem('growth-acquisition-attribution-v02');
      }
    } catch { storageFailed = true; }
    if (storageFailed) history.coverage = 'storage_unavailable';
    for (const root of allRoots) {
      root.dataset.growthConsent = String(history.consent);
      root.dataset.growthPlatformPrivacy = win.Shopify?.customerPrivacy ? (platformAllows() ? 'allowed' : 'blocked') : 'unavailable';
      try { root.dataset.growthOptionalStorage = String(!!(win.sessionStorage.getItem(TAB_KEY) || win.localStorage.getItem(STORAGE_KEY))); }
      catch { root.dataset.growthOptionalStorage = 'unavailable'; }
    }
  };
  persist();
  if (!win.Shopify?.customerPrivacy && win.Shopify?.loadFeatures) {
    win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => persist());
  }
  const updateLinks = () => {
    for (const root of allRoots) {
      const own = pairs.find(pair => pair.root === root)?.context || context;
      const current = { ...(root.hasAttribute('data-growth-global') ? context : own), product_interest: product };
      const links = draftLinks(current, acceptedReference, market, { email: 'nairy@nrmech.com', whatsapp: '8613989601729' });
      root.querySelectorAll('[data-growth-channel]').forEach(anchor => { anchor.href = links[anchor.dataset.growthChannel]; });
    }
    doc.querySelectorAll('[data-growth-internal]').forEach(anchor => {
      const next = new URL(anchor.getAttribute('href'), win.location.origin);
      if (next.origin !== win.location.origin) return;
      next.searchParams.set('market', market);
      if (anchor.hasAttribute('data-growth-technical') || anchor.hasAttribute('data-growth-contact-link')) {
        next.searchParams.set('product_interest', product);
        next.searchParams.set('origin_page_id', context.page_id);
      }
      anchor.href = next.pathname + next.search;
    });
  };
  updateLinks();
  for (const { root, context: linkContext } of pairs) {
    root.querySelectorAll('[data-growth-channel]').forEach(anchor => {
      anchor.addEventListener('click', () => measurement.contact(anchor.dataset.growthChannel,
        { ...linkContext, market, product_interest: product }, history.consent));
    });
  }
  for (const { root, context: formContext } of pairs) {
    const form = root.querySelector('[data-growth-form]');
    if (!form) continue;
    if (!NOTICE_CONTRACT.supported_locales.includes(formContext.language)
        || formContext.endpoint !== NOTICE_CONTRACT.endpoint
        || formContext.notice_version !== NOTICE_CONTRACT.notice_version
        || formContext.contract_version !== NOTICE_CONTRACT.contract_version) continue;
    const controller = createPendingSubmission(dependencies);
    const freezeInputs = createInputFreeze(form);
    controllers.push({ controller, form });
    const result = form.querySelector('[data-growth-result]');
    const button = form.querySelector('button[type=submit]');
    form.querySelector('fieldset').disabled = false;
    form.elements.market.value = market;
    form.elements.product_interest.value = product;
    form.elements.attribution_consent.checked = history.consent || form.elements.attribution_consent.defaultChecked;
    form.addEventListener('input', () => {
      if (['pending', 'sending', 'uncertain'].includes(controller.view().state)) return;
      if (controller.editedAfterAcceptance()) {
        result.textContent = '';
        delete result.dataset.receiptStatus;
        delete result.dataset.persisted;
        acceptedReference = 'unlinked';
      }
      market = form.elements.market.value;
      product = form.elements.product_interest.value;
      const consent = form.elements.attribution_consent.checked && platformAllows();
      history = consent ? mergeHistory(history.consent ? history : null, readTouch(formContext, win.location.href, doc.referrer), true) : mergeHistory(null, essentialTouch(), false);
      history.coverage = history.consent ? 'consented' : 'session_only';
      persist(); updateLinks();
    });
    form.querySelector('[data-growth-withdraw]').addEventListener('click', () => {
      controllers.forEach(item => item.controller.withdrawAttribution());
      history = mergeHistory(null, essentialTouch(), false);
      allRoots.forEach(item => { const checkbox = item.querySelector('[name=attribution_consent]'); if (checkbox) checkbox.checked = false; });
      try { win.localStorage.removeItem(STORAGE_KEY); win.sessionStorage.removeItem(TAB_KEY); }
      catch { history.coverage = 'storage_unavailable'; }
      persist();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      button.disabled = true;
      try {
        if (!platformAllows()) controller.withdrawAttribution();
        let pending = controller.view().pendingPayload;
        if (!pending) {
          if (form.elements.notice_acknowledged.checked !== true) contractFailure('notice_acknowledgement_required');
          const current = { ...formContext, product_interest: product, market };
          const readFields = dependencies.readFields || (currentForm => Object.fromEntries(new FormData(currentForm).entries()));
          const fields = readFields(form);
          persist();
          pending = controller.prepare({
            page_id: current.page_id, page_version: current.page_version,
            language: current.language, market, product_interest: product, application_code: current.application_code,
            origin_page_id: current.origin_page_id || null, cta_id: `${current.page_id}:form:form`,
            name: fields.name, company: fields.company, email: fields.email,
            phone: fields.phone || '', application: fields.application, material: fields.material || '',
            required_capacity: fields.required_capacity || '', feed_size: fields.feed_size || '', message: fields.message || '',
            details: Object.fromEntries(Array.from(form.querySelectorAll('[data-growth-detail]'), input => [input.name, input.value])),
            notice_acknowledged: true, notice_version: NOTICE_CONTRACT.notice_version,
            attribution: history.consent ? history : { consent: false, coverage: 'session_only' },
          });
        }
        freezeInputs(true);
        const receipt = await controller.attempt(pending);
        result.textContent = receipt.reference;
        result.dataset.receiptStatus = receipt.status;
        result.dataset.persisted = 'true';
        result.dataset.notificationStatus = receipt.notification_status;
        result.dataset.market = pending.market;
        result.dataset.language = pending.language;
        result.dataset.product = pending.product_interest;
        if (pending.attribution.first_touch) {
          const attribution = normalizedAttribution(pending.attribution, formContext, pending.market, pending.product_interest, pending.application, pending.cta_id);
          result.dataset.source = attribution.source;
          result.dataset.campaign = attribution.campaign || '';
          result.dataset.landing = attribution.landing_page;
        }
        result.dataset.analyticsStatus = measurement.accepted(receipt, pending,
          { ...formContext, market: pending.market, product_interest: pending.product_interest },
          pending.attribution?.consent === true && history.consent === true);
        result.dataset.adsEventStatus = adsMeasurement.accepted(receipt, pending,
          pending.attribution?.consent === true && history.consent === true);
        acceptedReference = receipt.reference;
        updateLinks();
        freezeInputs(false);
      } catch {
        result.textContent = result.dataset.error;
        delete result.dataset.receiptStatus;
        delete result.dataset.persisted;
        delete result.dataset.notificationStatus;
        if (controller.view().pendingPayload) freezeInputs(true);
      } finally { button.disabled = false; }
    });
  }
  doc.addEventListener('visitorConsentCollected', () => {
    if (!platformAllows()) {
      controllers.forEach(item => item.controller.withdrawAttribution());
      history = mergeHistory(null, essentialTouch(), false);
      allRoots.forEach(root => { const input = root.querySelector('[name=attribution_consent]'); if (input) input.checked = false; });
      persist();
    }
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeGrowthTheme());
  else initializeGrowthTheme();
}

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nairy-feeder-product-style"] && !Shopify.designMode) return;
  try {
    (function(){
  document.querySelectorAll('[data-gf-gallery]').forEach(function(g){
    var track=g.querySelector('[data-gf-track]'); if(!track) return;
    var slides=track.querySelectorAll('.gf-slide'); var cur=g.querySelector('[data-gf-current]'); var total=g.querySelector('[data-gf-total]');
    if(total) total.textContent=slides.length;
    function update(){ var i=Math.round(track.scrollLeft/track.clientWidth)+1; if(cur) cur.textContent=Math.max(1,Math.min(i,slides.length)); }
    g.querySelector('[data-gf-prev]')?.addEventListener('click',function(){track.scrollBy({left:-track.clientWidth,behavior:'smooth'})});
    g.querySelector('[data-gf-next]')?.addEventListener('click',function(){track.scrollBy({left:track.clientWidth,behavior:'smooth'})});
    track.addEventListener('scroll',update,{passive:true}); update();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
